import { Form } from 'components/ui/atoms';
import { AddressForm } from 'components/ui/organisms/address-form';
import CountryAutoFill from 'components/ui/organisms/country-auto-fill';
import MonarchResolver from 'components/ui/organisms/monarch/MonarchResolver';
import { ValueReinforcementResult } from 'components/ui/organisms/monarch/rules/valueReinforcement/types';
import { ValueReinforcement } from 'components/ui/organisms/value-reinforcement';
import { getAccountCountry } from 'helpers/utils/account';
import { getIsStripeCTAPending, useAppSelector } from 'store';
import { useStripeOptions } from 'frontastic/hooks';
import { useAccount } from 'frontastic/hooks/useAccount';
import { addressSchema } from './address-schema';
import { PlaceOrderButton } from './place-order-button';
import { StripeForm } from './stripe-form';
import { AddressSchema, CheckoutFormProps } from './types';

export const CheckoutForm = (props: CheckoutFormProps) => {
  const {
    shouldAutoFillPii = false,
    onBillingCountryChange,
    ...restProps
  } = props;
  const isStripeCTAPending = useAppSelector(getIsStripeCTAPending);
  const account = useAccount();

  const { placeStripeOrder } = useStripeOptions();

  const handleSubmit = (address: AddressSchema) => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    placeStripeOrder({ address, data: restProps });
  };

  return (
    <>
      <Form
        aria-label="checkout-form"
        onSubmit={handleSubmit}
        validationSchema={addressSchema}
        defaultValues={{
          // First/Last name work with SSR (account data available during SSR)
          firstName: shouldAutoFillPii ? String(account?.firstName ?? '') : '',
          lastName: shouldAutoFillPii ? String(account?.lastName ?? '') : '',
          address: '',
          unit: '',
          city: '',
          // Country is client-side only - start empty, will be filled by CountryAutoFill
          country: shouldAutoFillPii ? '' : getAccountCountry(account),
          state: '',
          stateCode: 'not-required',
          postalCode: '',
        }}
      >
        <CountryAutoFill shouldAutoFillPii={Boolean(shouldAutoFillPii)} />
        <AddressForm
          isDisabled={isStripeCTAPending}
          variant="checkout"
          onBillingCountryChange={onBillingCountryChange}
        />
        <StripeForm isDisabled={isStripeCTAPending} />
        <PlaceOrderButton isCTAPending={isStripeCTAPending} />
      </Form>
      <MonarchResolver<ValueReinforcementResult>
        experimentKey="useValueReinforcement"
        variants={{
          control: null,
          test: <ValueReinforcement />,
        }}
        fallbackVariant="control"
        Loader={<div>Loading...</div>}
      />
    </>
  );
};
